module.exports = __webpack_public_path__ + "img/icon_map_5_off_110.6e95fb8c.png";